import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { SellingAPetScreen, SellingAPetScreenProps } from 'shared/screens/selling-a-pet';
import { withServerProps } from '@web/library/with-server-props';

export default function SellingAPet(props: SellingAPetScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) => seo.forPage(t('selling_a_pet.title'), t('selling_a_pet.description'))}
    >
      <SellingAPetScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
